import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { balanceApi } from 'services/apiDigitalTicket/balance';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as balanceActions from './actions';
import { balanceTypes } from './types';

function* getBalance({
  payload,
}: ReturnType<typeof balanceActions.getBalanceRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando listagem de compras do usuário',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(balanceApi.balanceGet, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        balanceActions.getBalanceSuccess({
          balanceList: response.data,
          totalCount: parseInt(response.headers.totalCount, 10),
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('Wallet - History - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(balanceActions.getBalanceFailure());
    yield put(DialogsActions.setClose());
  }
}

function* walletDebit({
  payload,
}: ReturnType<typeof balanceActions.walletDebitRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Efetuando operação...',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(balanceApi.walletDebit, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(balanceActions.walletDebitSuccess());
      yield put(DialogsActions.setClose());
      yield put(DialogsActions.setSecondClose());
      yield put(
        balanceActions.getBalanceRequest({
          userId: payload.userId,
          startDate: new Date().setHours(0, 0, 0),
          endDate: new Date().setHours(23, 59, 59),
          type: [],
          usageType: [],
          paymentType: [],
          history: true,
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('Wallet - History - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(balanceActions.walletDebitFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const balanceSagas = [
  takeLatest(balanceTypes.GET_BALANCE_REQUEST, getBalance),
  takeLatest(balanceTypes.WALLET_DEBIT_REQUEST, walletDebit),
];
